import React from 'react';
import { X, useIsInIframe, useWasOpenedByWindowOpen } from 'shared-components';

// Circular close button in the top-right of the wizard. Mirrors the
// styling of Volt's BCMSignupCloseButton but preserves Apply's pre-
// existing behaviour: the close affordance only exists when "close"
// has a real target (partner popup or iframe embed). In standalone
// browser tabs it returns null so we don't present a dead button —
// matching what CloseWindowButton / CloseIframeButton used to do.
export const BCMShortCloseButton: React.FC = () => {
  const isOpenedInWindow = useWasOpenedByWindowOpen();
  const isOpenedInIframe = useIsInIframe();

  if (!isOpenedInWindow && !isOpenedInIframe) {
    return null;
  }

  const handleClose = () => {
    // Popup opened via window.open — mirror the original CloseWindowButton
    // behaviour (window.close()) plus postMessage so the opener can react.
    if (isOpenedInWindow && typeof window !== 'undefined') {
      if (window.opener) {
        window.opener.postMessage(JSON.stringify({ type: 'close' }), '*');
      }
      window.close();
      return;
    }

    // Iframe embed — identical postMessage to original CloseIframeButton.
    if (isOpenedInIframe && typeof window !== 'undefined' && window.parent !== window) {
      window.parent.postMessage(JSON.stringify({ type: 'close' }), '*');
    }
  };

  return (
    <button
      type="button"
      onClick={handleClose}
      className="bg-dawn border border-charcoal2 flex items-center justify-center rounded-full w-[35px] h-[35px] shadow-[0px_0px_15px_0px_rgba(13,13,13,0.05)] hover:opacity-70 transition-opacity cursor-pointer"
      aria-label="Close"
    >
      <X className="h-[14px] w-[14px]" stroke="#0d0d0d" />
    </button>
  );
};
